exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vs-con-tbody[data-v-f1a03572] {\n  border: none !important;\n}\n.icon-select .vs__dropdown-menu[data-v-f1a03572] {\n  height: 80px !important;\n  z-index: 200001!important;\n}\n.module-select .vs__dropdown-menu[data-v-f1a03572] {\n  height: 80px !important;\n}\n.addto-select .vs__dropdown-menu[data-v-f1a03572] {\n  height: 80px !important;\n}\r\n", ""]);

// exports
